import React from "react";
import BannerImage from "./BannerImage";
import LeftImgRightText from "./LeftImgRightText";
import RightImgLeftText from "./RightImgLeftText";
import "../App.css";

const GameGuard = () => {
  document.title = "GameGuard";

  return (
    <div className="ui">
      <BannerImage
        title={"Play to win"}
        image={require("../assets/img/cc/gg1.jpg")}
      />

      <div className="marginTopBtm">
        <LeftImgRightText
          image={require("../assets/img/cc/ss.png")}
          text={"GameGuard"}
          obj={{
            title: "Bible based",
            desc: "Learn and practice biblical knowledge",
            dl: "Download to play and compete now!",
          }}
          links={{
            ios: "https://apps.apple.com/us/app/gameguard/id1501027282",
            android:
              "https://play.google.com/store/apps/details?id=io.devjo.gameguard",
          }}
        />
      </div>

      <div className="altColor marginTopBtm">
        <RightImgLeftText
          image={require("../assets/img/cc/cc2.png")}
          text={"GameGuard"}
          obj={{
            title: "Multiple Categories",
            desc: "5 categories to choose from!",
            dl:
              "Make your choice and own it. Can choose from Characters, Books, Pastors, Terms and Quick Play.",
          }}
          links={{
            ios: "https://apps.apple.com/us/app/gameguard/id1501027282",
            android:
              "https://play.google.com/store/apps/details?id=io.devjo.gameguard",
          }}
        />
      </div>

      <div className="marginTopBtm">
        <LeftImgRightText
          image={require("../assets/img/cc/cc3.png")}
          text={"GameGuard"}
          obj={{
            title: "Show and Guess",
            desc: "Understand your friends description and guess the word",
            dl:
              "Place device in front of your forehead and guess the word that your friends are describing. Flip up to skip and down if you guessed correctly.",
          }}
          links={{
            ios: "https://apps.apple.com/us/app/gameguard/id1501027282",
            android:
              "https://play.google.com/store/apps/details?id=io.devjo.gameguard",
          }}
        />
      </div>

      <div className="altColor marginTopBtm">
        <RightImgLeftText
          image={require("../assets/img/cc/cc4.png")}
          text={"GameGuard"}
          obj={{
            title: "Analyse your results",
            desc: "Know what you don't know",
            dl:
              "See which words you are not familiar with and find where does the word appears in the bible.",
          }}
          links={{
            ios: "https://apps.apple.com/us/app/gameguard/id1501027282",
            android:
              "https://play.google.com/store/apps/details?id=io.devjo.gameguard",
          }}
        />
      </div>

      <div className="marginTopBtm">
        <LeftImgRightText
          image={require("../assets/img/cc/cc5.png")}
          text={"GameGuard"}
          obj={{
            title: "Time extension",
            desc: "Need more time each turn? Too fast?",
            dl:
              "Head to the settings by clicking the gear icon on the top right of the app to adjust the gameplay time to your preference.",
          }}
          links={{
            ios: "https://apps.apple.com/us/app/gameguard/id1501027282",
            android:
              "https://play.google.com/store/apps/details?id=io.devjo.gameguard",
          }}
        />
      </div>
    </div>
  );
};

export default GameGuard;
